<div class="highcharts-tooltip">
  <span *ngIf="y != null">
    <div>
      <span class="metric-tooltip title comp_title capitalize tile_body">{{
        name
      }}</span>
      <span
        class="metric-tooltip value comp_value tooltip_value"
        [ngStyle]="{ color: color }"
      >
        {{ prefix }}{{ y | number }}{{ suffix }}
      </span>
    </div>
    <div>
      <span class="metric-tooltip subtitle">{{ subtitle }}</span>
    </div>
    <div
      class="metric-tooltip comp_description body_tooltip_text"
      *ngIf="suffix"
    >
      <strong>{{ numerator | number }}</strong> of
      <strong>{{ denominator | number }}</strong> students {{ descriptor }}
    </div>
    <div
      class="metric-tooltip comp_description body_tooltip_text"
      *ngIf="!suffix"
    >
      <strong>{{ numerator | number }}</strong> students {{ descriptor }}
    </div>
  </span>
  <span *ngIf="y == null">
    <span class="metric-tooltip title comp_title capitalize tile_body"
      >No data available</span
    >
    <div class="metric-tooltip comp_description body_tooltip_text">
      We couldn't find any data for this metric.
    </div>
  </span>
</div>
